import React, { FC } from 'react';
import Image from 'next/image';
import { styled } from 'linaria/react';
import { FormatAliasPhone, formatPhoneNumber } from '@shared/lib/phone';
import { toPriceFormat } from '@shared/lib/money';
import { Spinner, Text } from '@shared/ui/atoms';
import { Tooltip } from '@shared/ui/organisms';
import { SquareQuestionIcon } from '@shared/assets/icons';
import mtsBalanceIcon from '@shared/assets/images/cyber/icons/mtsBalance.png';
import { withTheme } from '@shared/lib/theme';
import { useBindingsStore } from '../model/useBindingsStore';
import { getMtsBinding } from '../lib/getMtsBinding';
import { useAuthDataStore } from '../model/useAuthDataStore';
const MtsClientCard: FC = () => {
  const {
    getPhone
  } = useAuthDataStore();
  const {
    bindings,
    isLoading
  } = useBindingsStore();
  const mtsBinding = getMtsBinding(bindings);
  return <MtsClientCardWrapper>
      <ContentWrapper>
        <ImageWrapper>
          <Image aria-hidden objectFit="cover" width={64} height={64} alt="icon" src={mtsBalanceIcon} />
        </ImageWrapper>
        {isLoading ? <Spinner /> : <TextWrapper>
            <Text family="MTSCompact" weight="medium" size={{
          desktop: 'pL',
          mobile: 'pM'
        }} color="primary">
              {toPriceFormat(mtsBinding?.balance as number, {
            trimIfInteger: true
          })} ₽
            </Text>
            <Text family="MTSCompact" weight="medium" size={{
          desktop: 'pS',
          mobile: 'captionL'
        }} color="secondary">
              {formatPhoneNumber(getPhone() || '89080493424', FormatAliasPhone.SYMBOLS16)}
            </Text>
          </TextWrapper>}
      </ContentWrapper>
      <TooltipWrapper>
        <Tooltip content="Это средства, которые можно использовать для пополнения аккаунта. Сумма может не совпадать с балансом на счёту вашего номера">
          <SquareQuestionIcon />
        </Tooltip>
      </TooltipWrapper>
    </MtsClientCardWrapper>;
};
export default MtsClientCard;
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.background.tertiary;
const MtsClientCardWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "MtsClientCardWrapper",
  class: "m1ysxo06",
  propsAsIs: false,
  vars: {
    "m1ysxo06-0": [_exp()]
  }
}));
const ContentWrapper = /*#__PURE__*/styled('div')({
  name: "ContentWrapper",
  class: "ceqlp3w",
  propsAsIs: false
});
const ImageWrapper = /*#__PURE__*/styled('div')({
  name: "ImageWrapper",
  class: "i1g7xpj3",
  propsAsIs: false
});
const TextWrapper = /*#__PURE__*/styled('div')({
  name: "TextWrapper",
  class: "t1w9lzya",
  propsAsIs: false
});
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.icon.tertiary;
const TooltipWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "TooltipWrapper",
  class: "t3nll40",
  propsAsIs: false,
  vars: {
    "t3nll40-0": [_exp2()]
  }
}));

require("./MtsClientCard.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./MtsClientCard.tsx");